<template>
  <v-app>
    <!-- <v-app-bar
      v-if="$estadoApp.usuario"
      color="#FFE0B2"
      app
      dark
    >
    <v-row>
      <v-col cols="8" >
        <span  style="font-family: Monospace;  font-size: 19px; font-weight: bold;color:black;" class="pa-2 d-flex justify-center">Zona de Descargas
        </span>
      </v-col>
      <v-col cols="4" class="mt-1">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon   v-bind="attrs" v-on="on" style="color:black;" v-show="$estadoApp.usuario" >
              mdi-account
            </v-icon>
          </template>
          {{$estadoApp.usuario}}
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
            v-bind="attrs" v-on="on"
            color="black"
            left
            text
            outlined
            v-show="$estadoApp.usuario"
            @click="cerrarSesion"
            >
            <v-icon>
              mdi-logout-variant
            </v-icon>
            </v-btn>
          </template>
          Cerrar sesión
        </v-tooltip>
      </v-col>
    </v-row>
    </v-app-bar> -->
    <v-app-bar v-if="$estadoApp.usuario" app color="#FFE0B2" dark>
      <v-img
        alt="Equinsa Logo"
        class="shrink mt-1 hidden-sm-and-down"
        contain
        src="./assets/equinsa.png"
        width="100"
      />
      <v-spacer></v-spacer>
      <span
        style="
          font-family: Monospace;
          letter-spacing: -0.2px;
          font-size: 24px;
          font-weight: bold;
          color: black;
        "
        class="pa-2 d-flex justify-center"
        >Zona de Descargas
      </span>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            class="hidden-sm-and-down"
            v-bind="attrs"
            v-on="on"
            style="color: black"
            v-show="$estadoApp.usuario"
          >
            mdi-account
          </v-icon>
        </template>
        {{ $estadoApp.usuario }}
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="ml-1"
            v-bind="attrs"
            v-on="on"
            color="black"
            left
            text
            outlined
            v-show="$estadoApp.usuario"
            @click="cerrarSesion"
          >
            <v-icon> mdi-logout-variant </v-icon>
          </v-btn>
        </template>
        Cerrar sesión
      </v-tooltip>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>

    <div v-if="$estadoApp.cargando" class="pantalla_carga">
      <div class="fondo_pantalla_carga"></div>
      <div class="centrar_vertical text-center">
        <v-progress-circular
          :size="70"
          :width="7"
          color="#bead87"
          indeterminate
        ></v-progress-circular>
      </div>
    </div>
    <dialogo ref="dialogo" />
  </v-app>
</template>

<script>
import dialogo from "./components/dialogo";
import ApiZD from "./apiZonaDeDescargas";
export default {
  name: "App",

  data: () => ({
    //
  }),
  components: {
    dialogo,
  },
  mounted() {
    this.$root.$dialogo = this.$refs.dialogo;
  },
  methods: {
    editarUsuario() {
      this.$router.push({ path: "/gestionUsuario/" + this.$estadoApp.usuario });
    },

    cerrarSesion() {
      // El registro remoto es secundario: incluso sin red hay que poder salir.
      ApiZD.cerrarSesion().catch(() => {});
      this.$root.$estadoApp.cerrarSesion();
      if (this.$router.currentRoute.path !== "/") {
        this.$router.replace({ path: "/" }).catch(() => {});
      }
    },
  },
};
</script>

<style scoped>
* {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
#app {
  background-color: #fffaf3;
}

.centrar_vertical {
  position: absolute;
  width: 100%;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.pantalla_carga {
  position: absolute;
  width: 100%;
  height: 100%;
}
.fondo_pantalla_carga {
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.5;
}
</style>
